var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        viewBox: "0 0 16 35",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("rect", {
        attrs: { width: "16", height: "35", fill: "currentBackgroundColor" }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M11.0937 27L12.0938 28L8.04688 32.0469L4 28L5 27L8.04688 30.0469L11.0937 27Z",
          fill: "#555555"
        }
      }),
      _vm._v(" "),
      _c("path", { attrs: { d: "M2 19H14V24H2V19Z", fill: "#FAA7A9" } }),
      _vm._v(" "),
      _c("path", { attrs: { d: "M2 9H14V14H2V9Z", fill: "#DD4C4E" } }),
      _vm._v(" "),
      _c("path", { attrs: { d: "M2 14H14V19H2V14Z", fill: "#F87275" } }),
      _vm._v(" "),
      _c("path", { attrs: { d: "M2 4H14V9H2V4Z", fill: "#D83336" } })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }